import { CircularProgress, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Link from '@material-ui/core/Link';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { Autocomplete } from '@mui/material';
import Handlebars from 'handlebars';
import JoditEditor from "jodit-react";
import _uniqueId from 'lodash/uniqueId';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import MUIDataTable from 'mui-datatables';
import { Component } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from './_layout/spinner';
import { getDatafromApi, getAllFromApi, handleCallApi } from './calls';
import { ApiData, MapboxKey } from "./config";
import paybylinkTemplate from './template_email';
import uploadIcon from './themes/icons/uploadicon.png';
import { handleBase64Upload, handlePhotoUpload, handleUploadFile } from "./uploadFiles";
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

let pointNumbers = [];
let selectedRowIndex = [];

const CURRENCIES = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  ILS: '₪'
};

class SelfGuidedPackagePersonalized extends Component {
  constructor(props) {
    super(props);
    this.debounceTimer = null;
    this.editorButtons = [
      'source', '|',
      'undo', 'redo', '|',
      'font', 'fontsize', 'bold', 'italic', 'underline', '|',
      'ul',
      'ol', '|',
      'outdent', 'indent', '|',
      'align',
    ];
    this.editorConfigs = {
      selfGuideDesc: {
        buttons: this.editorButtons,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'insert_as_html',
        id: 'selfGuide_desc',
      },
      priceDescription: {
        buttons: this.editorButtons,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'insert_as_html',
        id: 'editor_price_description',
      },
      priceDescriptionHebrew: {
        buttons: this.editorButtons,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'insert_as_html',
        id: 'price_description_hebrew',
        direction: 'rtl',
        placeholder: 'הקלד כאן...',
      },
      priceIncludes: {
        buttons: this.editorButtons,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'insert_as_html',
        id: 'price_selfGuide_price_includes',
      },
      priceIncludesHebrew: {
        buttons: this.editorButtons,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'insert_as_html',
        id: 'price_selfGuide_price_includes_hebrew',
        direction: 'rtl',
        placeholder: 'הקלד כאן...',
      },
      priceExcluded: {
        buttons: this.editorButtons,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'insert_as_html',
        id: 'price_selfGuide_price_excluded',
      },
      priceExcludedHebrew: {
        buttons: this.editorButtons,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'insert_as_html',
        id: 'selfGuide_price_excluded_hebrew',
        direction: 'rtl',
        placeholder: 'הקלד כאן...',
      },
      confirmationPolicy: {
        buttons: this.editorButtons,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'insert_as_html',
        id: 'confirmation_policy',
      },
      confirmationPolicyHebrew: {
        buttons: this.editorButtons,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'insert_as_html',
        id: 'confirmation_policy_hebrew',
        direction: 'rtl',
        placeholder: 'הקלד כאן...',
      },
      contentEmail: {
        buttons: this.editorButtons,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: 'insert_as_html',
        id: 'content_email',
      },
    };
    this.state = {
      fields: {},
      errors: {},
      photourl: '',
      webphotoLoc: '',
      selfGuideTableData: [['Loading Data...']],
      updateSGRowIndex: '',
      PNCount: 1,
      SNCount: 1,
      selfGuide_tripName: '',
      selfGuide_country: '',
      selfGuide_trip: '',
      selfGuide_subTitle: '',
      selfGuide_desc: '',
      selfGuide_car_model: '',
      selfGuide_price: '',
      price_description: '',
      price_description_hebrew: '',
      selfGuide_price_includes: '',
      selfGuide_price_includes_hebrew: '',
      selfGuide_price_excluded: '',
      selfGuide_price_excluded_hebrew: '',
      selfGuide_photo: '',
      save_type: 'add',
      number_travelers: 0,
      showModal: false,
      openDeleteCnfrm: false,
      editableSPId: '',
      starting_date: '1970-01-01',
      ending_date: '1970-01-01',
      searchData: [],
      allTrip: [],
      tripsLoading: false,
      confirmation_policy: '<h4>PlanYourTrip – Cancellation Policy</h4><p>Up to 45 days before departure - Free of Charge (100% refundable)</p><p>Up to 21 days before departure - 20% of the value of the tour (80% refundable)</p><p>Up to 48 hours before departure - 50% of the value of the tour (50% refundable)</p><p>Less than 48 hours before departure - 100% of the tour (nonrefundable any longer)</p>',
      showEmailField: false,
      searchTerm: '',
      emails: [],
      selectedEmail: '',
      userFirstName: '',
      userLastName: '',
      selectedCurrency: '€',
      currencies: Object.keys(CURRENCIES),
      overnightPreCity: '',
      overnightPostNight: '',
      overnightPreHotel: '',
      overnightPostHotel: '',
      overnightPreHotelSiteLink: '',
      overnightPostHotelSiteLink: '',
      hotelNames: [],
      hotelSites: [],
      trip: {},
      car_name: '',
      priceIncludes: '',
      mapPhotoUrl: '',
      tripPhotoUrl: '',
      hotelOptions: [],
      searchTermHotel: '',
      searchTermOvernightHotel: '',
      contentEmail: '',
      days_data: [],
      user_data: [],
      confirmation_policy_hebrew: '',
      offerLanguage: 'en',
      generatedHtml: '',
      tripDropdownLoading: false,
      allHotelsData: [],
      vouchers: [],
      vouchersUploading: false
    };
  }

  componentDidMount() {
    this.getTrip();
    if (window.location.hostname === 'localhost') {
      this.setState({
        userFirstName: 'Israel',
        userLastName: 'Israeli',
        selectedEmail: 'israel@example.com'
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {

  }

  async getTrip() {
    try {
      const data = await getDatafromApi(
        ApiData.apiUrl + '/trips/simple-trips'
      );
      const trips = data || [];
      if (trips && trips.length > 2) {
        trips.sort((a, b) => a.id - b.id);
        this.setState({ allTrip: trips });
      } else if (trips) {
        this.setState({ allTrip: trips });
      }
    } catch (error) {
      this.setState({ allTrip: [] });
    }
  }

  handleSelfGuideValidation() {
    let errors = {};
    let formIsValid = true;
    let errorMessage = ''
    if (!this.state.selfGuide_trip) {
      formIsValid = false;
      errors['selfGuide_trip'] = 'Please Select Trip';
      errorMessage = 'Please Select Trip';
    }
    if (!this.state.selfGuide_photo) {
      formIsValid = false;
      errors['selfGuide_photo'] = 'You must select a photo';
      errorMessage = 'You must select a photo';
    }
    if (!this.state.selfGuide_price) {
      formIsValid = false;
      errors['price'] = 'Price Is not empty';
      errorMessage = 'Price Is not empty';
    }
    if (isNaN(parseInt(this.state.selfGuide_price))) {
      formIsValid = false;
      errors['price'] = 'Not a Valid price';
      errorMessage = 'Not a Valid price';
    }
    if (!formIsValid) {
      toast.error(errorMessage);
    }
    this.setState({ errors: errors });
    return formIsValid;
  }

  handleSaveSelfGuide = async (e) => {
    e.preventDefault();
    toast.dismiss();
    if (this.handleSelfGuideValidation()) {
      this.checkHotelDaysSelected();
      let selfGuideData1 = [...this.state.selfGuideTableData];
      const [year, month, day] = this.state.starting_date.split('-');
      const formattedDate = `${day}/${month}/${year}`;
      const [endYear, endMonth, endDay] = this.state.ending_date.split('-');
      const formattedEndDate = `${endDay}/${endMonth}/${endYear}`;
      const daysData = [];
      if (this.state.trip && Array.isArray(this.state.trip.days)) {
        this.state.trip.days.forEach((day, i) => {
          let data = {};
          data.hotelName = this.state.hotelNames[i] || '';
          data.hotelSite = this.state.hotelSites[i] || '';
          data.overnightPreCity = this.state.overnightPreCity;
          data.overnightPostNight = this.state.overnightPostNight;
          data.overnightPreHotel = this.state.overnightPreHotel;
          data.overnightPostHotel = this.state.overnightPostHotel;
          data.overnightPreHotelSiteLink = this.state.overnightPreHotelSiteLink;
          data.overnightPostHotelSiteLink = this.state.overnightPostHotelSiteLink;
          data.contentEmail = this.state.contentEmail;
          daysData.push(data);
        });
      }
      const userData = [{
        firstName: this.state.userFirstName,
        lastName: this.state.userLastName,
        selectedEmail: this.state.selectedEmail,
        selectedCurrency: this.state.selectedCurrency
      }];

      let apidata = {
        "trip_id": this.state.selfGuide_trip,
        "photo": this.state.selfGuide_photo,
        "price": Number(this.state.selfGuide_price),
        "price_includes": this.state.selfGuide_price_includes,
        "price_includes_hebrew": this.state.selfGuide_price_includes_hebrew,
        "price_description": this.state.price_description,
        "price_description_hebrew": this.state.price_description_hebrew,
        "excluded": this.state.selfGuide_price_excluded,
        "excluded_hebrew": this.state.selfGuide_price_excluded_hebrew,
        "personalized": true,
        "starting_date": formattedDate,
        "ending_date": formattedEndDate,
        'number_travelers': this.state.number_travelers,
        'confirmation_policy': this.state.confirmation_policy,
        "confirmation_policy_hebrew": this.state.confirmation_policy_hebrew,
        "language": this.state.offerLanguage,
        'days_data': daysData,
        'user_data': userData,
        'vouchers': this.state.vouchers || [],
      }
      let method = 'POST';
      let success = '';
      let url1 = ApiData.apiUrl + `/self-guided-packages/`;
      if (this.state.save_type !== 'add') {
        method = 'PUT';
        url1 = ApiData.apiUrl + `/self-guided-packages/${this.state.editableSPId}`;
        success = `Self Guided Package Updated (ID: ${this.state.editableSPId})`;
        selfGuideData1[this.state.updateSGRowIndex].trip_id = this.state.selfGuide_trip
        selfGuideData1[this.state.updateSGRowIndex].photo = this.state.selfGuide_photo
        selfGuideData1[this.state.updateSGRowIndex].price = Number(this.state.selfGuide_price)
        selfGuideData1[this.state.updateSGRowIndex].price_includes_hebrew = this.state.selfGuide_price_includes_hebrew
        selfGuideData1[this.state.updateSGRowIndex].price_includes = this.state.selfGuide_price_includes
        selfGuideData1[this.state.updateSGRowIndex].price_description = this.state.price_description
        selfGuideData1[this.state.updateSGRowIndex].price_description_hebrew = this.state.price_description_hebrew
        selfGuideData1[this.state.updateSGRowIndex].excluded = this.state.selfGuide_price_excluded
        selfGuideData1[this.state.updateSGRowIndex].excluded_hebrew = this.state.selfGuide_price_excluded_hebrew
        selfGuideData1[this.state.updateSGRowIndex].number_travelers = this.state.number_travelers
        selfGuideData1[this.state.updateSGRowIndex].confirmation_policy = this.state.confirmation_policy
        selfGuideData1[this.state.updateSGRowIndex].confirmation_policy_hebrew = this.state.confirmation_policy_hebrew
        selfGuideData1[this.state.updateSGRowIndex].language = this.state.offerLanguage
        selfGuideData1[this.state.updateSGRowIndex].starting_date = formattedDate
        selfGuideData1[this.state.updateSGRowIndex].ending_date = formattedEndDate
        selfGuideData1[this.state.updateSGRowIndex].days_data = daysData
        selfGuideData1[this.state.updateSGRowIndex].user_data = userData
        selfGuideData1[this.state.updateSGRowIndex].vouchers = this.state.vouchers || []
        this.setState({ selfGuideTableData: selfGuideData1 })
      }
      let data = await handleCallApi(method, url1, JSON.stringify(apidata), success, '', { autoClose: 6000 });
      if (data) {
        if (this.state.save_type === 'add') {
          selfGuideData1.unshift(data);
          this.setState({ selfGuideTableData: selfGuideData1 })
          toast.success(`SGP ${data.id} created`, { autoClose: 6000 });
        }
        else {
          if (this.state.searchData) {
            const updatedSearchData = [...this.state.searchData];
            updatedSearchData[this.state.updateSGRowIndex] = data;
            this.setState({ searchData: updatedSearchData })
          }
        }
        this.setState({
          selfGuide_tripName: '',
          selfGuide_country: '',
          selfGuide_trip: '',
          selfGuide_subTitle: '',
          selfGuide_desc: '',
          selfGuide_price: '',
          selfGuide_price_includes: '',
          selfGuide_price_includes_hebrew: '',
          price_description: '',
          price_description_hebrew: '',
          selfGuide_photo: '',
          selfGuide_price_excluded: '',
          editableSPId: '',
          number_travelers: 0,
          starting_date: '1970-01-01',
          ending_date: '1970-01-01',
          confirmation_policy: "<h4>PlanYourTrip – Cancellation Policy</h4><p>Up to 45 days before departure - Free of Charge (100% refundable)</p><p>Up to 21 days before departure - 20% of the value of the tour (80% refundable)</p><p>Up to 48 hours before departure - 50% of the value of the tour (50% refundable)</p><p>Less than 48 hours before departure - 100% of the tour (nonrefundable any longer)</p>",
          confirmation_policy_hebrew: "",
          offerLanguage: 'en',
          vouchers: [],
          vouchersUploading: false,
        });

        closePopoup();
      }
    }
    else {
      toast.error('Missing Information / Fields');
    }
  }

  async checkHotelDaysSelected() {
    const hotelNameMismatches = [];

    await Promise.all(this.state.trip.days.map(async (day, index) => {
      if (this.state.hotelNames[index] && day.hotel && day.hotel.length > 0) {
        if (this.state.hotelNames[index] !== this.state.trip.days[index].hotel[0].hotel_name) {
          hotelNameMismatches.push({
            dayId: this.state.trip.days[index].id,
            hotelName: this.state.hotelNames[index],
          });
        }
        return this.state.hotelNames[index] === day.hotel[0].hotel_name;
      }
      return false;
    }));

    if (hotelNameMismatches.length === 0) {
    } else {
      const method = "PUT";
      const success = 'Day Updated';
      const error = 'Missing Information / Fields';
      await Promise.all(hotelNameMismatches.map(async (data) => {
        const hotelData = await getDatafromApi(ApiData.baseURL + `/hotels-prices-list/name/${data.hotelName}/${this.state.trip.country}/true`);
        const apidata = {
          ending_point: { latitude: parseFloat(hotelData[0].latitude), longitude: parseFloat(hotelData[0].longitude) },
          overnight: hotelData[0].overnight_city
        };
        await handleCallApi(method, ApiData.apiUrl + `/days/overnight/${data.dayId}?admin=true`, JSON.stringify(apidata), success, error);
      }));
    }
  }

  handlePhotoForEmail = async (event) => {
    try {
      const url = await handleBase64Upload(event, 'planmytrip-assets', 'paybylink');
      if (url) {
        return url;
      }
    } catch (error) {
    }
  };

  async generateMapImage(coordinates, width = 1500, height = 900) {
    if (coordinates.length === 0 || isNaN(coordinates[0].longitude) || isNaN(coordinates[0].latitude)) {
      return null;
    }
    const mapContainer = document.createElement('div');
    mapContainer.style.width = `${width}px`;
    mapContainer.style.height = `${height}px`;

    const map = new mapboxgl.Map({
      container: mapContainer,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [coordinates[0].longitude, coordinates[0].latitude],
      zoom: 5,
    });

    await new Promise((resolve) => {
      map.on('style.load', () => {
        resolve();
      });
    });

    map.addSource('markersAndLines', {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: coordinates.map((markerData) => ({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [markerData.longitude, markerData.latitude],
          },
          properties: {},
        })),
      },
    });

    map.addLayer({
      id: 'markers',
      type: 'circle',
      source: 'markersAndLines',
      paint: {
        'circle-color': '#8a2be2', // Violeta
        'circle-radius': 6,
      },
    });

    // Agregar líneas entre los marcadores
    map.addLayer({
      id: 'lines',
      type: 'line',
      source: 'markersAndLines',
      paint: {
        'line-color': '#8a2be2', // Violeta
        'line-width': 2,
      },
    });

    // Esperar a que el mapa esté completamente cargado
    await new Promise((resolve) => {
      map.once('idle', () => {
        resolve();
      });
    });

    // Obtener la imagen del mapa como base64
    const mapImage = await map.getCanvas().toDataURL('image/png');

    // Limpiar el mapa
    map.remove();
    return mapImage;
  }

  warnIfMissingHebrewDayNames() {
    if (this.state.offerLanguage !== 'he' || !this.state.trip || !Array.isArray(this.state.trip.days)) return;
    const missing = this.state.trip.days.filter((day) => !day.nameHebrew).map((day) => day.name);
    if (missing.length > 0) {
      toast.warn(`Offer language is Hebrew but ${missing.length} day(s) have no Hebrew name and will show in English: ${missing.join(', ')}`, { autoClose: 8000 });
    }
  }

  async sendEmail() {
    if (this.handleSelfGuideValidation() && this.state.trip && Array.isArray(this.state.trip.days)) {

      if (this.state.userFirstName.trim() === '' || this.state.selectedEmail.trim() === '' || this.state.userLastName.trim() === '') {
        toast.error('You need to fill the form');
        return;
      }

      this.warnIfMissingHebrewDayNames();

      this.setState({ loading: true });

      try {
        // Fetch local hero data
        let localHero = await getDatafromApi(ApiData.apiUrl + `/local-hero/country/${this.state.trip.country}`);

        // Register Handlebars helper
        Handlebars.registerHelper('if_eq', function (a, b, opts) {
          if (a === b) {
            return opts.fn(this);
          } else {
            return opts.inverse(this);
          }
        });

        // Compile the template
        const template = Handlebars.compile(paybylinkTemplate);

        // Prepare days data
        const days = await Promise.all(this.state.trip.days.map(async (day, i) => {
          const isFirstDay = i === 0;
          const isLastDay = i === this.state.trip.days.length - 1;

          let web_poi_set = day.web_poi_set ? await Promise.all(day.web_poi_set.map(async (poi) => {
            let poiName = '';
            if (this.state.offerLanguage === 'he') {
              const name = poi.nameHebrew || poi.name || '';
              const desc = poi.descriptionHebrew || '';
              poiName = name + (desc ? ' ' + desc : '');
            } else {
              const name = poi.name || '';
              const desc = poi.description || '';
              poiName = name + (desc ? ' - ' + desc : '');
            }

            let innerStops = [];
            if (poi.type === 2 && poi.gpx) {
              try {
                const gpx = await getDatafromApi(ApiData.baseURL + "/vg/gpxs/" + poi.gpx + "/");
                if (gpx && gpx.waypoints) {
                  innerStops = gpx.waypoints
                    .filter((wp) => wp.type === 5)
                    .map((wp) => ({
                      ...wp,
                      nameHebrew: wp.nameHebrew || wp.name,
                      descriptionHebrew: wp.descriptionHebrew || wp.description,
                      country: poi.country,
                      photo: poi.photo,
                      gpx: null,
                      type: 0,
                      longitude: wp.location.longitude,
                      latitude: wp.location.latitude,
                    }));
                }
              } catch (e) {
                console.error("Error fetching GPX for POI:", poi.id, e);
              }
            }

            return { ...poi, name: poiName, innerStops };
          })) : [];

          const overnight = (this.state.offerLanguage === 'he' && day.overnight_hebrew) ? day.overnight_hebrew : day.overnight;

          return {
            ...day,
            dayIndex: i + 1,
            firstDay: isFirstDay,
            lastDay: isLastDay,
            hotelName: (this.state.hotelNames && this.state.hotelNames[i])
              ? this.state.hotelNames[i] : '',
            siteLinkHotel: (day.hotel && day.hotel.length) > 0 ? day.hotel[0].site_link : '',
            name: this.state.offerLanguage === 'he' ? (day.nameHebrew || day.name) : day.name,
            description: this.state.offerLanguage === 'he' ? (day.descriptionHebrew || day.description) : day.description,
            web_poi_set: web_poi_set,
            overnight: overnight
          };
        }));

        const tripName = this.state.offerLanguage === 'he' ? this.state.trip.nameHebrew : this.state.trip.name;

        // Generate HTML from template
        const fullName = [this.state.userFirstName, this.state.userLastName].filter(Boolean).join(' ');
        const compiledHtml = template({
          reference: fullName ? tripName + " - " + this.state.userFirstName + "-" + this.state.userLastName : tripName,
          username: fullName,
          country: this.state.trip.country,
          days_count: this.state.trip.days_count,
          days: days,
          price: this.state.selfGuide_price,
          price_description: this.state.offerLanguage === 'he' ? this.state.price_description_hebrew : this.state.price_description,
          price_includes: this.state.offerLanguage === 'he' ? this.state.selfGuide_price_includes_hebrew : this.state.selfGuide_price_includes,
          price_excludes: this.state.offerLanguage === 'he' ? this.state.selfGuide_price_excluded_hebrew : this.state.selfGuide_price_excluded,
          confirmation_policy: this.state.offerLanguage === 'he' ? this.state.confirmation_policy_hebrew : this.state.confirmation_policy,
          direction: this.state.offerLanguage === 'he' ? 'rtl' : 'ltr',
          trip_intro_text: this.state.offerLanguage === 'he' ? `זהו המסלול המותאם אישית שלך ל-${this.state.trip.days_count} ימים ב${this.state.trip.country}. המסלול שלך כולל:` : `This is your personalized ${this.state.trip.days_count}-days trip to ${this.state.trip.country}. Your trip includes:`,
          personalized_itinerary_title: this.state.offerLanguage === 'he' ? `מסלול מותאם אישית ל-${this.state.trip.days_count} ימים` : `${this.state.trip.days_count}-days Personalized Itinerary`,
          personalized_itinerary_text: this.state.offerLanguage === 'he' ? 'לאחר שתכננת את הטיול שלך, המסלול המותאם אישית שלך מוכן.' : 'Once you planned your trip, your personalized itinerary is ready.',
          navigational_guide_title: this.state.offerLanguage === 'he' ? 'מדריך ניווט לטיול' : 'Navigational Tour Guide',
          navigational_guide_text: this.state.offerLanguage === 'he' ? 'נווט את כל המסלול שלך תוך כדי תנועה וקבל טיפים רלוונטיים לאורך הדרך.' : 'Navigate your entire itinerary on the go and receive relevant tips along your route.',
          local_hero_title: this.state.offerLanguage === 'he' ? 'גיבור מקומי בשטח בשבילך' : 'Local Hero on the Ground for You',
          local_hero_text: this.state.offerLanguage === 'he' ? 'יהיה שם בשבילך לייעץ, לארגן, לעזור ולהציע.' : 'Will be there for you advising, arranging, helping, suggesting.',
          price_per_person_label: this.state.offerLanguage === 'he' ? 'מחיר לאדם' : 'Price per person',
          price_includes_label: this.state.offerLanguage === 'he' ? 'המחיר כולל' : 'Price includes',
          price_excludes_label: this.state.offerLanguage === 'he' ? 'המחיר לא כולל' : 'Price excludes',
          local_hero_img: localHero.profile_pic,
          package_img: this.state.selfGuide_photo,
          currency: this.state.selectedCurrency,
          overnightPreCity: (this.state.overnightPreCity || '').trim(),
          overnightPostNight: (this.state.overnightPostNight || '').trim(),
          overnightPreHotel: (this.state.overnightPreHotel || '').trim(),
          overnightPostHotel: (this.state.overnightPostHotel || '').trim(),
          contentEmail: this.state.contentEmail,
          overnightPreHotelSiteLink: this.state.overnightPreHotelSiteLink,
          overnightPostHotelSiteLink: this.state.overnightPostHotelSiteLink,
        });

        // Prepare filename for PDF
        const filename = `${this.state.trip.name}-${this.state.userFirstName}-${this.state.userLastName}.pdf`;

        // Step 1: Convert HTML to PDF using convert-html endpoint
        toast.info('Generating PDF... This may take a moment.');

        const convertResponse = await fetch(`${ApiData.baseURL}/pdf/convert-html`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            html: compiledHtml,
            filename: filename,
          }),
        });

        if (!convertResponse.ok) {
          const errorData = await convertResponse.json().catch(() => ({}));
          throw new Error(errorData.message || `PDF conversion failed: ${convertResponse.status} ${convertResponse.statusText}`);
        }

        // Get PDF as blob
        const pdfBlob = await convertResponse.blob();

        // Step 2: Send email with PDF attachment using send-email endpoint
        toast.info('Sending email with PDF attachment...');

        const formData = new FormData();
        formData.append('attachment', pdfBlob, filename);
        formData.append('email', this.state.selectedEmail);
        formData.append('subject', `${this.state.trip.internal_name} - ${this.state.userFirstName} ${this.state.userLastName}`);
        formData.append('text', `Hello ${this.state.userFirstName} ${this.state.userLastName}, please find your personalized itinerary attached.`);

        const emailResponse = await fetch(`${ApiData.baseURL}/vg/send-email`, {
          method: 'POST',
          body: formData,
        });

        if (!emailResponse.ok) {
          const errorData = await emailResponse.json().catch(() => ({}));
          throw new Error(errorData.message || `Email sending failed: ${emailResponse.status} ${emailResponse.statusText}`);
        }

        await emailResponse.json();
        toast.success('Email sent successfully with PDF attachment!');

      } catch (error) {
        console.error('Error sending email:', error);
        toast.error(`Failed to send email: ${error.message}`);
      } finally {
        this.setState({ loading: false });
      }
    }
  }

  async convertHtmlToPdf(html, filename) {
    try {
      toast.info('Generating PDF... This may take a moment.');

      const response = await fetch(`${ApiData.baseURL}/pdf/convert-html`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          html: html,
          filename: filename,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Server error: ${response.status} ${response.statusText}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      toast.success('PDF downloaded successfully!');
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error(`Failed to generate PDF: ${error.message}`);
    }
  }

  async viewEmail() {
    if (this.handleSelfGuideValidation() && this.state.trip && Array.isArray(this.state.trip.days)) {
      this.warnIfMissingHebrewDayNames();

      let localHero = await getDatafromApi(ApiData.apiUrl + `/local-hero/country/${this.state.trip.country}`)

      Handlebars.registerHelper('if_eq', function (a, b, opts) {
        if (a === b) {
          return opts.fn(this);
        } else {
          return opts.inverse(this);
        }
      });

      const template = Handlebars.compile(paybylinkTemplate);
      const days = await Promise.all(this.state.trip.days.map(async (day, i) => {
        const isFirstDay = i === 0;
        const isLastDay = i === this.state.trip.days.length - 1;

        let web_poi_set = day.web_poi_set ? await Promise.all(day.web_poi_set.map(async (poi) => {
          let poiName = '';
          if (this.state.offerLanguage === 'he') {
            const name = poi.nameHebrew || poi.name || '';
            const desc = poi.descriptionHebrew || '';
            poiName = name + (desc ? ' ' + desc : '');
          } else {
            const name = poi.name || '';
            const desc = poi.description || '';
            poiName = name + (desc ? ' - ' + desc : '');
          }

          let innerStops = [];
          if (poi.type === 2 && poi.gpx) {
            try {
              const gpx = await getDatafromApi(ApiData.baseURL + "/vg/gpxs/" + poi.gpx + "/");
              if (gpx && gpx.waypoints) {
                innerStops = gpx.waypoints
                  .filter((wp) => wp.type === 5)
                  .map((wp) => ({
                    ...wp,
                    nameHebrew: wp.nameHebrew || wp.name,
                    descriptionHebrew: wp.descriptionHebrew || wp.description,
                    country: poi.country,
                    photo: poi.photo,
                    gpx: null,
                    type: 0,
                    longitude: wp.location.longitude,
                    latitude: wp.location.latitude,
                  }));
              }
            } catch (e) {
              console.error("Error fetching GPX for POI:", poi.id, e);
            }
          }

          return { ...poi, name: poiName, innerStops };
        })) : [];

        const overnight = (this.state.offerLanguage === 'he' && day.overnight_hebrew) ? day.overnight_hebrew : day.overnight;

        return {
          ...day,
          dayIndex: i + 1,
          firstDay: isFirstDay,
          lastDay: isLastDay,
          hotelName: (this.state.hotelNames && this.state.hotelNames[i])
            ? this.state.hotelNames[i] : '',
          siteLinkHotel: (day.hotel && day.hotel.length) > 0 ? day.hotel[0].site_link : '',
          name: this.state.offerLanguage === 'he' ? (day.nameHebrew || day.name) : day.name,
          description: this.state.offerLanguage === 'he' ? (day.descriptionHebrew || day.description) : day.description,
          web_poi_set: web_poi_set,
          overnight: overnight
        };
      }));

      const tripName = this.state.offerLanguage === 'he' ? this.state.trip.nameHebrew : this.state.trip.name;

      const fullName = [this.state.userFirstName, this.state.userLastName].filter(Boolean).join(' ');
      const compiledHtml = template({
        reference: fullName ? tripName + " - " + this.state.userFirstName + "-" + this.state.userLastName : tripName,
        username: fullName,
        country: this.state.trip.country,
        days_count: this.state.trip.days_count,
        days: days,
        price: this.state.selfGuide_price,
        price_description: this.state.offerLanguage === 'he' ? this.state.price_description_hebrew : this.state.price_description,
        price_includes: this.state.offerLanguage === 'he' ? this.state.selfGuide_price_includes_hebrew : this.state.selfGuide_price_includes,
        price_excludes: this.state.offerLanguage === 'he' ? this.state.selfGuide_price_excluded_hebrew : this.state.selfGuide_price_excluded,
        confirmation_policy: this.state.offerLanguage === 'he' ? this.state.confirmation_policy_hebrew : this.state.confirmation_policy,
        direction: this.state.offerLanguage === 'he' ? 'rtl' : 'ltr',
        trip_intro_text: this.state.offerLanguage === 'he' ? `זהו המסלול המותאם אישית שלך ל-${this.state.trip.days_count} ימים ב${this.state.trip.country}. המסלול שלך כולל:` : `This is your personalized ${this.state.trip.days_count}-days trip to ${this.state.trip.country}. Your trip includes:`,
        personalized_itinerary_title: this.state.offerLanguage === 'he' ? `מסלול מותאם אישית ל-${this.state.trip.days_count} ימים` : `${this.state.trip.days_count}-days Personalized Itinerary`,
        personalized_itinerary_text: this.state.offerLanguage === 'he' ? 'לאחר שתכננת את הטיול שלך, המסלול המותאם אישית שלך מוכן.' : 'Once you planned your trip, your personalized itinerary is ready.',
        navigational_guide_title: this.state.offerLanguage === 'he' ? 'מדריך ניווט לטיול' : 'Navigational Tour Guide',
        navigational_guide_text: this.state.offerLanguage === 'he' ? 'נווט את כל המסלול שלך תוך כדי תנועה וקבל טיפים רלוונטיים לאורך הדרך.' : 'Navigate your entire itinerary on the go and receive relevant tips along your route.',
        local_hero_title: this.state.offerLanguage === 'he' ? 'גיבור מקומי בשטח בשבילך' : 'Local Hero on the Ground for You',
        local_hero_text: this.state.offerLanguage === 'he' ? 'יהיה שם בשבילך לייעץ, לארגן, לעזור ולהציע.' : 'Will be there for you advising, arranging, helping, suggesting.',
        price_per_person_label: this.state.offerLanguage === 'he' ? 'מחיר לאדם' : 'Price per person',
        price_includes_label: this.state.offerLanguage === 'he' ? 'המחיר כולל' : 'Price includes',
        price_excludes_label: this.state.offerLanguage === 'he' ? 'המחיר לא כולל' : 'Price excludes',
        local_hero_img: localHero.profile_pic,
        package_img: this.state.selfGuide_photo,
        currency: this.state.selectedCurrency,
        overnightPreCity: (this.state.overnightPreCity || '').trim(),
        overnightPostNight: (this.state.overnightPostNight || '').trim(),
        overnightPreHotel: (this.state.overnightPreHotel || '').trim(),
        overnightPostHotel: (this.state.overnightPostHotel || '').trim(),
        contentEmail: this.state.contentEmail,
        overnightPreHotelSiteLink: this.state.overnightPreHotelSiteLink,
        overnightPostHotelSiteLink: this.state.overnightPostHotelSiteLink,
      });
      // Save the generated HTML to state for later use
      this.setState({ generatedHtml: compiledHtml });

      const emailWindow = window.open();
      emailWindow.document.write(compiledHtml);
      emailWindow.document.close();

      toast.success('HTML generated and saved successfully!');

      const filename = `${this.state.trip.name}-${this.state.userFirstName || 'trip'}-${this.state.userLastName || 'itinerary'}.pdf`;
      await this.convertHtmlToPdf(compiledHtml, filename);
    }
  }

  handleEmailSelect(event) {
    if (event.target && event.target.value !== undefined) {
      this.setState({ selectedEmail: event.target.value });
    } else {
      console.error('Invalid event or value:', event);
    }
  }

  handleSearchTermChange(event) {
    const searchValue = event.target.value;
    this.setState({ searchTerm: searchValue, selectedEmail: searchValue });

    // Clear existing timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Don't search for empty strings
    if (searchValue === '') {
      this.setState({ emails: [] });
      return;
    }

    // Set new timer - only fire API call after 300ms of no typing
    this.debounceTimer = setTimeout(async () => {
      let emailsData = await getDatafromApi(ApiData.baseURL + `/user/emails?q=${searchValue}`);
      if (emailsData) {
        this.setState({ emails: emailsData });
      }
    }, 300);
  };

  handleCurrencyChange(event) {
    this.setState({ selectedCurrency: event.target.value });
  }

  setEditableSelfPackageId = (id) => {
    this.setState({ editableSPId: id });
  }

  setSGSearchData = async (data) => {
    this.setState({ searchData: data });
  };

  handlePhoto = async (event) => {
    try {
      const url = await handlePhotoUpload(event, 'planmytrip-assets', 'selfGuidedPackages');
      if (url) {
        this.setState({ selfGuide_photo: url });
      }
    } catch (error) {
    }
  };

  deletePopUpData = () => {
    this.setState({
      contentEmail: '',
      hotelNames: [],
      hotelOptions: [],
      hotelSites: [],
      overnightPostHotel: '',
      overnightPostHotelSiteLink: '',
      overnightPostNight: '',
      overnightPreCity: '',
      overnightPreHotel: '',
      overnightPreHotelSiteLink: '',
      searchTerm: '',
      searchTermHotel: '',
      searchTermOvernightHotel: '',
      selectedEmail: '',
      userFirstName: '',
      userLastName: '',
      days_data: [],
      user_data: [],
      offerLanguage: 'en',
      vouchers: [],
      vouchersUploading: false,
    })
  };

  setSelfGuideData = async (confirmation_policy, confirmation_policy_hebrew, price_description, price_description_hebrew, trip, photo, selfGuide_price, selfGuide_price_includes, selfGuide_price_includes_hebrew, selfGuide_price_excluded, selfGuide_price_excluded_hebrew, starting_date, ending_date, save_type, updateSGRowIndex, number_travelers, days_data, user_data, vouchers = [], language = 'en') => {
    const dateFormated = this.convertToISODate(starting_date);
    const endingDateFormated = ending_date ? this.convertToISODate(ending_date) : dateFormated;
    let tripData = trip ? await getDatafromApi(ApiData.apiUrl + `/trips/${trip}`) : null;
    let priceIncludes = selfGuide_price_includes;
    let carData = [];
    let overnightPreCityData = '';
    let overnightPostNightData = '';
    let overnightPreHotelData = '';
    let overnightPostHotelData = '';
    let overnightPreHotelSiteLinkData = '';
    let overnightPostHotelSiteLinkData = '';
    let contentEmailData = '';
    let userLastName = '';
    let selectedEmail = '';
    let userFirstName = '';
    let selectedCurrency = '';
    let hotelNamesData = [];
    let hotelSitesData = [];
    if (tripData) {
      carData = await getDatafromApi(ApiData.baseURL + `/car-rental-prices-list/country/${tripData.country}/true`);
      let nightsInTrip = tripData ? tripData.days_count - 1 : 0;
      let daysInTrip = tripData ? tripData.days_count : 0;
      priceIncludes = nightsInTrip > 0 ? priceIncludes.replace(/&lt;number_of_nights&gt;/g, String(nightsInTrip)) : '';
      priceIncludes = daysInTrip > 0 ? priceIncludes.replace(/&lt;number_of_days&gt;/g, String(daysInTrip)) : '';
      if (carData.length > 0 && carData[0].car_name) {
        priceIncludes = priceIncludes.replace(/&lt;car_model&gt;/g, carData[0].car_name);
      }
      this.setState({ priceIncludes: priceIncludes });
      if (Array.isArray(days_data) && days_data.length > 0) {
        days_data.forEach(data => {
          hotelNamesData.push(data.hotelName);
          hotelSitesData.push(data.hotelSite);
        });
        overnightPreCityData = days_data[0].overnightPreCity;
        overnightPostNightData = days_data[0].overnightPostNight;
        overnightPreHotelData = days_data[0].overnightPreHotel;
        overnightPostHotelData = days_data[0].overnightPostHotel;
        overnightPreHotelSiteLinkData = days_data[0].overnightPreHotelSiteLink;
        overnightPostHotelSiteLinkData = days_data[0].overnightPostHotelSiteLink;
        contentEmailData = days_data[0].contentEmail;
      }
      if (Array.isArray(user_data) && user_data.length > 0) {
        userLastName = user_data[0].lastName || user_data[0].userLastName || '';
        selectedEmail = user_data[0].selectedEmail;
        userFirstName = user_data[0].firstName || user_data[0].userFirstName || '';
        selectedCurrency = user_data[0].selectedCurrency;
      }

      // Fetch all hotels for the country (all 4 permutations)
      try {
        const [tt, tf, ft, ff] = await Promise.all([
          getDatafromApi(ApiData.baseURL + `/hotels-prices-list/country/${tripData.country}/true/true`),
          getDatafromApi(ApiData.baseURL + `/hotels-prices-list/country/${tripData.country}/true/false`),
          getDatafromApi(ApiData.baseURL + `/hotels-prices-list/country/${tripData.country}/false/true`),
          getDatafromApi(ApiData.baseURL + `/hotels-prices-list/country/${tripData.country}/false/false`)
        ]);

        let combinedHotels = [];
        const mergeData = (data) => {
          if (Array.isArray(data)) {
            data.forEach(hotel => {
              if (!combinedHotels.find(h => h.id === hotel.id)) {
                combinedHotels.push(hotel);
              }
            });
          }
        };

        mergeData(tt);
        mergeData(tf);
        mergeData(ft);
        mergeData(ff);

        if (combinedHotels.length > 0) {
          const options = combinedHotels.map(h => h.hotel_name);
          this.setState({ allHotelsData: combinedHotels, hotelOptions: options });
        }
      } catch (error) {
        console.error('Error fetching hotels:', error);
      }
    }
    this.setState({
      confirmation_policy,
      confirmation_policy_hebrew,
      showModal: true,
      selfGuide_photo: photo,
      selfGuide_trip: trip,
      selfGuide_price: selfGuide_price,
      selfGuide_price_includes: priceIncludes,
      selfGuide_price_includes_hebrew: selfGuide_price_includes_hebrew,
      price_description: price_description,
      price_description_hebrew: price_description_hebrew,
      selfGuide_price_excluded: selfGuide_price_excluded,
      selfGuide_price_excluded_hebrew: selfGuide_price_excluded_hebrew,
      starting_date: dateFormated,
      ending_date: endingDateFormated,
      save_type: save_type,
      updateSGRowIndex: updateSGRowIndex,
      number_travelers,
      trip: tripData,
      days_data,
      user_data,
      overnightPreCity: overnightPreCityData,
      overnightPostNight: overnightPostNightData,
      overnightPreHotel: overnightPreHotelData,
      overnightPostHotel: overnightPostHotelData,
      overnightPreHotelSiteLink: overnightPreHotelSiteLinkData,
      overnightPostHotelSiteLink: overnightPostHotelSiteLinkData,
      hotelNames: hotelNamesData,
      hotelSites: hotelSitesData,
      contentEmail: contentEmailData,
      userLastName: userLastName,
      selectedEmail: selectedEmail,
      userFirstName: userFirstName,
      selectedCurrency: selectedCurrency,
      offerLanguage: language || 'en',
      vouchers: Array.isArray(vouchers) ? vouchers : [],
      vouchersUploading: false,
    });
  };

  handleVoucherUpload = async (event) => {
    try {
      const files = Array.from(event?.target?.files || []);
      if (!files.length) {
        return;
      }
      this.setState({ vouchersUploading: true });
      const uploadedUrls = [];
      for (const file of files) {
        const url = await handleUploadFile({ target: { files: [file] } }, 'planmytrip-assets', 'selfGuidedPackages/vouchers');
        if (url) {
          uploadedUrls.push(url);
        }
      }
      if (uploadedUrls.length > 0) {
        this.setState((prevState) => ({
          vouchers: [...(prevState.vouchers || []), ...uploadedUrls]
        }));
      }
      if (event && event.target) {
        event.target.value = '';
      }
    } catch (error) {
      toast.error('Error uploading voucher file');
    } finally {
      this.setState({ vouchersUploading: false });
    }
  };

  removeVoucher = (indexToRemove) => {
    this.setState((prevState) => ({
      vouchers: (prevState.vouchers || []).filter((_, index) => index !== indexToRemove)
    }));
  };

  async handleHotelChange(value, i) {
    if (!value || value === '') {
      return;
    }
    // Autocomplete handles local filtering naturally, but we can set hotelOptions here if we want to limit the dropdown
    // For now, we'll keep hotelOptions as the full list and let Autocomplete filter
  }

  handleHotelSelect(value, i) {
    if (value) {
      const hotel = this.state.allHotelsData.find(h => h.hotel_name === value);
      if (hotel) {
        const updatedHotelNames = [...this.state.hotelNames];
        const updatedhotelSites = [...this.state.hotelSites];
        updatedHotelNames[i] = hotel.hotel_name;
        updatedhotelSites[i] = hotel.site_link;
        this.setState({ hotelNames: updatedHotelNames, hotelSites: updatedhotelSites });
      } else {
        // Free solo manual entry
        const updatedHotelNames = [...this.state.hotelNames];
        updatedHotelNames[i] = value;
        this.setState({ hotelNames: updatedHotelNames });
      }
    }
  }

  async handleOverNightHotelChange(value, isPre) {
    if (!value || value === '') {
      return;
    }
  }

  handleOverNightHotelSelect(value, isPre) {
    if (value) {
      const hotel = this.state.allHotelsData.find(h => h.hotel_name === value);
      if (hotel) {
        if (isPre) {
          this.setState({ overnightPreHotel: hotel.hotel_name, overnightPreHotelSiteLink: hotel.site_link });
        } else {
          this.setState({ overnightPostHotel: hotel.hotel_name, overnightPostHotelSiteLink: hotel.site_link });
        }
      } else {
        // Free solo manual entry
        if (isPre) {
          this.setState({ overnightPreHotel: value });
        } else {
          this.setState({ overnightPostHotel: value });
        }
      }
    }
  }

  convertToISODate = (ddmmyyyy) => {
    if (!ddmmyyyy || typeof ddmmyyyy !== 'string' || ddmmyyyy.includes('<div')) {
      return new Date().toISOString().split('T')[0];
    }
    const parts = ddmmyyyy.split('/');
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return ddmmyyyy;
  }

  setSelfGuideTableData = async (data) => {
    this.setState({ selfGuideTableData: data });
  };

  handleFromDateChange = (event) => {
    const fromDate = event.target.value;
    this.setState({ starting_date: fromDate });
  }

  handleToDateChange = (event) => {
    const toDate = event.target.value;
    this.setState({ ending_date: toDate });
  }

  handleClickOpen = () => {
    if (selectedRowIndex.length > 0)
      this.setState({ openDeleteCnfrm: true });
  };

  handleDelete = () => {
    this.setState({ openDeleteCnfrm: false });

    var array = [...this.state.selfGuideTableData];
    selectedRowIndex.sort(function (a, b) {
      return b - a;
    });
    selectedRowIndex.forEach(async (i) => {
      let delid = array[i].id;
      array.splice(i, 1);
      await handleCallApi('DELETE', ApiData.apiUrl + `/self-guided-packages/${delid}/`, {}, '', '')
    })
    this.setSelfGuideTableData(array);
    selectedRowIndex = [];
  };

  handleClose = () => {
    this.setState({
      openDeleteCnfrm: false,
    });
    selectedRowIndex = [];
  };

  handleSelectTrip = async (tripId, selectedOption = null) => {
    if (tripId) {
      const localTrip = (this.state.allTrip || []).find((t) => Number(t.id) === Number(tripId));
      const initialPhoto = (selectedOption && selectedOption.photo) || (localTrip && localTrip.photo) || '';
      this.setState({
        selfGuide_trip: tripId,
        selfGuide_photo: initialPhoto
      });
      const apiData = await getDatafromApi(ApiData.apiUrl + `/trips/${tripId}`);
      const data = Array.isArray(apiData) ? apiData[0] : apiData;
      if (data) {
        const selectedTripPhoto = data.photo || initialPhoto || '';
        let hotelNames = [];
        let hotelSites = [];
        if (Array.isArray(data.days)) {
          data.days.forEach(() => {
            hotelNames.push('');
            hotelSites.push('');
          });
        }
        this.setState({
          trip: data,
          selfGuide_photo: selectedTripPhoto,
          overnightPreCity: data.overnight_pre_night || '',
          overnightPostNight: data.overnight_post_night || '',
          hotelNames: hotelNames,
          hotelSites: hotelSites
        });

        // Fetch all hotels for the country (all 4 permutations)
        try {
          const [tt, tf, ft, ff] = await Promise.all([
            getDatafromApi(ApiData.baseURL + `/hotels-prices-list/country/${data.country}/true/true`),
            getDatafromApi(ApiData.baseURL + `/hotels-prices-list/country/${data.country}/true/false`),
            getDatafromApi(ApiData.baseURL + `/hotels-prices-list/country/${data.country}/false/true`),
            getDatafromApi(ApiData.baseURL + `/hotels-prices-list/country/${data.country}/false/false`)
          ]);

          let combinedHotels = [];
          const mergeData = (data) => {
            if (Array.isArray(data)) {
              data.forEach(hotel => {
                if (!combinedHotels.find(h => h.id === hotel.id)) {
                  combinedHotels.push(hotel);
                }
              });
            }
          };

          mergeData(tt);
          mergeData(tf);
          mergeData(ft);
          mergeData(ff);

          if (combinedHotels.length > 0) {
            const options = combinedHotels.map(h => h.hotel_name);
            this.setState({ allHotelsData: combinedHotels, hotelOptions: options });
          }
        } catch (error) {
          console.error('Error fetching hotels:', error);
        }
      }
    }
  };

  render() {
    return (
      <div>

        <Dialog
          open={this.state.openDeleteCnfrm}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Delete"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are You Sure You Want to delete this Self Guide Package
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose}>Cancel</Button>
            <Button onClick={this.handleDelete} autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <div className="modal">
          <div className="modal_content">
            <span onClick={() => this.deletePopUpData()} className="close">&times;</span>
            <div className="model_html">
              {this.state.save_type !== 'add' ? <h2>{`EDIT A TRIP TO COUNTRY'S PACKAGE (ID: ${this.state.editableSPId})`}</h2>
                : <h2>ADD A TRIP TO COUNTRY'S PACKAGE</h2>}
              {this.state.showModal &&
                <table cellPadding="8" >
                  <tbody>
                    <tr style={{ display: 'none' }}>
                      <td width="35%" style={{ paddingRight: 30 }}>
                        <label>Country</label><br />
                        <ReactFlagsSelect
                          selected={this.state.selfGuide_country}
                          id={'selectCountriesDay'}
                          style={{ width: '70%' }}
                          showSelectedLabel={true}
                          showOptionLabel={true}
                          onSelect={(code) => { this.setState({ selfGuide_country: code }); }}
                          placeholder={'Select a Country'}
                          countries={['GR', 'CR', 'NO', 'IS', 'MX', 'ME', 'DK', 'IL', 'PL', 'PT', 'KR', 'EC', 'PE', 'MA', 'IN', 'ES', 'RO', 'ZA', 'GE', 'LK', 'CL', 'AR', 'AE', 'TZ', 'BG', 'IT', 'JP']}
                        />
                        <span className="errorMsg">{this.state.errors['selfGuide_country']}</span>
                      </td>
                      <td style={{ verticalAlign: 'baseline' }}>
                      </td>
                    </tr>
                    <tr>
                      <td width="35%" style={{ paddingRight: 30, verticalAlign: 'baseline' }}>
                        <label>SELECT TRIP</label><br />
                        <Autocomplete
                          options={this.state.allTrip || []}
                          loading={this.state.tripDropdownLoading}
                          getOptionLabel={(option) => `${option.internal_name} (${option.id})`}
                          value={
                            this.state.allTrip.find(
                              (t) => Number(t.id) === Number(this.state.selfGuide_trip)
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue) {
                              this.handleSelectTrip(newValue.id, newValue);
                            } else {
                              this.setState({
                                selfGuide_trip: '',
                                trip: {},
                                selfGuide_photo: ''
                              });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder={this.state.tripDropdownLoading ? 'Loading trips...' : 'Search trip...'}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {this.state.tripDropdownLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />

                        {/* <FormControl className="dropdownWithborder">
                          <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Type"
                            value={this.state.selfGuide_trip}
                            onChange={(event) => {
                              this.handleSelectTrip(event.target.value);
                            }}
                            multiple={false}
                          >
                            {this.state.allTrip.map((item, i) =>
                            (
                              <MenuItem key={item.id} value={item.id}>{item.internal_name}({item.id})</MenuItem>
                            )
                            )}
                          </Select>
                        </FormControl> */}
                        <span className="errorMsg">{this.state.errors['selfGuide_trip']}</span>
                      </td>
                      <td style={{ verticalAlign: 'baseline' }}>
                        <label>COVER PHOTO</label><br />
                        {this.state.selfGuide_photo ? [
                          <div key="photo-label"><span className="labelsmall"> Currently:<span className="colorgreen"> {this.state.selfGuide_photo}</span></span><br /><br />
                          </div>] : null}
                        <div className="divUpload">
                          <img alt="Upload" width="20px" src={uploadIcon} />
                          <Button variant="contained" component="label" style={{ float: 'right', fontSize: 9, }} >
                            UPLOAD FILE
                            <input
                              type="file"
                              hidden
                              id="fileSNPhoto"
                              size="small"
                              value=""
                              onChange={this.handlePhoto}
                            />
                          </Button>

                        </div>
                        <span className="errorMsg">{this.state.errors['selfGuide_photo']}</span>
                        <div>
                          {this.state.selfGuide_photo && <img style={{ height: '140px', width: '180px' }} src={this.state.selfGuide_photo} alt=""></img>}
                        </div>

                      </td>
                    </tr>
                    <tr style={{ display: 'none' }}>
                      <td colSpan="2">
                        <label>Trip Name</label><br />
                        <TextField
                          id="txtSNTitle"
                          style={{ width: '40%' }}
                          variant="outlined"
                          value={this.state.selfGuide_tripName}
                          error={!!this.state.errors['selfGuide_tripName']}
                          onChange={(event) =>
                            this.setState({ selfGuide_tripName: event.target.value })
                          }
                        />
                      </td>
                      <td>

                      </td>
                    </tr>
                    <tr style={{ display: 'none' }}>
                      <td style={{ paddingRight: 50 }}>
                        <label>SUB- TITLE (Trip Type Description)</label><br />
                        <TextField
                          id="txtSNTitle"
                          style={{ width: '100%' }}
                          variant="outlined"
                          value={this.state.selfGuide_subTitle}
                          error={!!this.state.errors['selfGuide_subTitle']}
                          onChange={(event) =>
                            this.setState({ selfGuide_subTitle: event.target.value })
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ display: 'none' }}>
                      <td colSpan="2">
                        <label>TRIP ITINERARY (DESCRIPTION)</label><br />
                        <JoditEditor
                          value={this.state.selfGuide_desc}
                          tabIndex={1}
                          style={{ innerHeight: 500 }}
                          onBlur={(value) => {
                            this.setState({ selfGuide_desc: value || '' })
                          }}
                          config={this.editorConfigs.selfGuideDesc}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <h3>PRICING</h3>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Price</label><br />
                        <TextField
                          id="txtSNTitle"
                          style={{ width: '40%' }}
                          variant="outlined"
                          value={this.state.selfGuide_price}
                          error={!!this.state.errors['price']}
                          onChange={(event) => {
                            const val = parseInt(event.target.value);
                            this.setState({ selfGuide_price: isNaN(val) ? '' : val });
                          }}
                        />
                        <br />
                        <span className="errorMsg">{this.state.errors['price']}</span>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Starting Date</label><br />
                        <input
                          type="date"
                          id="starting_date"
                          value={this.state.starting_date}
                          onChange={this.handleFromDateChange}
                        />
                        <br />
                        <span className="errorMsg">{this.state.errors['starting_date']}</span>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Ending Date</label><br />
                        <input
                          type="date"
                          id="ending_date"
                          value={this.state.ending_date}
                          onChange={this.handleToDateChange}
                        />
                        <br />
                        <span className="errorMsg">{this.state.errors['ending_date']}</span>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Number of Travelers:</label><br />
                        <input
                          type="number"
                          id="number_travelers"
                          value={this.state.number_travelers}
                          onChange={(event) =>
                            this.setState({ number_travelers: parseInt(event.target.value) })
                          }
                        />
                        <br />
                        <span className="errorMsg">{this.state.errors['number_travelers']}</span>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Offer Language:</label><br />
                        <select
                          value={this.state.offerLanguage}
                          onChange={(event) => this.setState({ offerLanguage: event.target.value })}
                          style={{ width: '40%' }}
                          id="offer-language-select"
                        >
                          <option value="he">Hebrew</option>
                          <option value="en">English</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Price Description:</label><br />
                        <JoditEditor
                          value={this.state.price_description}
                          tabIndex={1}
                          onBlur={(value) => this.setState({ price_description: value || '' })}
                          config={this.editorConfigs.priceDescription}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Price Description Hebrew:</label><br />
                        <JoditEditor
                          value={this.state.price_description_hebrew}
                          tabIndex={1}
                          onBlur={(value) => this.setState({ price_description_hebrew: value || '' })}
                          config={this.editorConfigs.priceDescriptionHebrew}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Price includes:</label><br />
                        <JoditEditor
                          value={this.state.selfGuide_price_includes}
                          tabIndex={1}
                          onBlur={(value) => this.setState({ selfGuide_price_includes: value || '' })}
                          config={this.editorConfigs.priceIncludes}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Price includes Hebrew:</label><br />
                        <JoditEditor
                          value={this.state.selfGuide_price_includes_hebrew}
                          tabIndex={1}
                          onBlur={(value) => this.setState({ selfGuide_price_includes_hebrew: value || '' })}
                          config={this.editorConfigs.priceIncludesHebrew}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Excluded:</label><br />
                        <JoditEditor
                          value={this.state.selfGuide_price_excluded}
                          tabIndex={1}
                          onBlur={(value) => this.setState({ selfGuide_price_excluded: value || '' })}
                          config={this.editorConfigs.priceExcluded}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Excluded Hebrew:</label><br />
                        <JoditEditor
                          value={this.state.selfGuide_price_excluded_hebrew}
                          tabIndex={1}
                          onBlur={(value) => this.setState({ selfGuide_price_excluded_hebrew: value || '' })}
                          config={this.editorConfigs.priceExcludedHebrew}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <label>Confirmation Policy:</label><br />
                        <JoditEditor
                          value={this.state.confirmation_policy}
                          tabIndex={1}
                          onBlur={(value) => this.setState({ confirmation_policy: value || '' })}
                          config={this.editorConfigs.confirmationPolicy}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td colSpan="2">
                        <label>Confirmation Policy Hebrew:</label><br />
                        <JoditEditor
                          value={this.state.confirmation_policy_hebrew}
                          tabIndex={1}
                          onBlur={(value) => this.setState({ confirmation_policy_hebrew: value || '' })}
                          config={this.editorConfigs.confirmationPolicyHebrew}
                        />
                      </td>
                    </tr>
                    {this.state.trip && Object.keys(this.state.trip).length > 0 &&
                      <tr>
                        <td colSpan="4">
                          <table cellPadding="8" className="dayHotelTable" style={{ borderCollapse: 'collapse', width: '100%' }}>
                            <thead>
                              <tr>
                                <th style={{ textAlign: 'center', border: '1px solid #ddd' }}>Day</th>
                                <th style={{ textAlign: 'center', border: '1px solid #ddd' }}>Overnight</th>
                                <th style={{ textAlign: 'center', border: '1px solid #ddd', width: '20%' }}>Hotel Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(this.state.trip?.days) && this.state.trip.days.map((day, i) => (
                                <tr key={i} style={{ borderBottom: '1px solid #ddd' }}>
                                  <td style={{ textAlign: 'center', border: '1px solid #ddd' }}>{`Day ${i + 1}`}</td>
                                  <td style={{ textAlign: 'center', border: '1px solid #ddd', width: '15%' }}>{day.overnight}</td>
                                  <td style={{ textAlign: 'center', border: '1px solid #ddd', width: '20%' }}>
                                    {i !== this.state.trip.days.length - 1 ? (
                                      <Autocomplete
                                        freeSolo
                                        options={this.state.hotelOptions}
                                        value={this.state.hotelNames && this.state.hotelNames.length > i ? this.state.hotelNames[i] : ''}
                                        onInputChange={(event, newInputValue) => {
                                          this.handleHotelChange(newInputValue, i);
                                        }}
                                        onChange={(event, newValue) => {
                                          this.handleHotelSelect(newValue, i);
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Hotel Name"
                                            sx={{ width: '100%' }}
                                          />
                                        )}
                                      />
                                    ) : (
                                      'End of the trip'
                                    )}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td colSpan="1" style={{ textAlign: 'center', border: '1px solid #ddd' }}>Overnight pre city</td>
                                <td style={{ textAlign: 'center', border: '1px solid #ddd', width: '20%' }}>
                                  <TextField
                                    type="text"
                                    value={this.state.overnightPreCity}
                                    onChange={(event) => this.setState({ overnightPreCity: event.target.value })}
                                  />
                                </td>
                                <td style={{ width: '20%' }}>
                                  <Autocomplete
                                    freeSolo
                                    options={this.state.hotelOptions}
                                    value={this.state.overnightPreHotel || ''}
                                    onInputChange={(event, newInputValue) => {
                                      this.handleOverNightHotelChange(newInputValue, true);
                                    }}
                                    onChange={(event, newValue) => {
                                      this.handleOverNightHotelSelect(newValue, true);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Hotel Name"
                                        sx={{ width: '100%' }}
                                      />
                                    )}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="1" style={{ textAlign: 'center', border: '1px solid #ddd' }}>Overnight post night</td>
                                <td style={{ textAlign: 'center', border: '1px solid #ddd', width: '20%' }}>
                                  <TextField
                                    type="text"
                                    value={this.state.overnightPostNight}
                                    onChange={(event) => this.setState({ overnightPostNight: event.target.value })}
                                  />
                                </td>
                                <td style={{ width: '20%' }}>
                                  <Autocomplete
                                    freeSolo
                                    options={this.state.hotelOptions}
                                    value={this.state.overnightPostHotel || ''}
                                    onInputChange={(event, newInputValue) => {
                                      this.handleOverNightHotelChange(newInputValue, false);
                                    }}
                                    onChange={(event, newValue) => {
                                      this.handleOverNightHotelSelect(newValue, false);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Hotel Name"
                                        sx={{ width: '100%' }}
                                      />
                                    )}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="1" style={{ textAlign: 'center', border: '1px solid #ddd' }}>Content of the email</td>
                                <td colSpan="2" style={{ textAlign: 'center', border: '1px solid #ddd', width: '20%' }}>
                                  <JoditEditor
                                    value={this.state.contentEmail}
                                    tabIndex={1}
                                    onBlur={(value) => { this.setState({ contentEmail: value || '' }) }}
                                    config={this.editorConfigs.contentEmail}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>}

                    {this.state.trip && Object.keys(this.state.trip).length > 0 &&
                      <tr><td colSpan="4"><table cellPadding="8" style={{ borderCollapse: 'collapse', marginTop: '20px', border: '1px solid #ddd' }}>
                        <tbody>
                          <tr>
                            <td colSpan="2">
                              <h3>Fill form to send email</h3>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              <TextField
                                type="text"
                                label="First name"
                                value={this.state.userFirstName}
                                sx={{ width: 400 }}
                                inputProps={{ style: { minHeight: 38 } }}
                                onChange={(event) => this.setState({ userFirstName: event.target.value })}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              <TextField
                                type="text"
                                label="Last name"
                                value={this.state.userLastName}
                                sx={{ width: 400 }}
                                inputProps={{ style: { minHeight: 38 } }}
                                onChange={(event) => this.setState({ userLastName: event.target.value })}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              <Autocomplete
                                freeSolo
                                options={this.state.emails}
                                value={this.state.selectedEmail}
                                onChange={(event, newValue) => {
                                  this.setState({
                                    selectedEmail: newValue || '',
                                    searchTerm: newValue || ''
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Please type email"
                                    onChange={this.handleSearchTermChange.bind(this)}
                                    sx={{ width: 400 }}
                                  />
                                )}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              <Select
                                value={this.state.selectedCurrency}
                                onChange={this.handleCurrencyChange.bind(this)}
                                sx={{ width: 400 }}
                              >
                                {this.state.currencies.map((currency, index) => (
                                  <MenuItem key={currency} value={CURRENCIES[currency]}>
                                    {currency}
                                  </MenuItem>
                                ))}
                              </Select>
                            </td>
                          </tr>
                        </tbody>
                      </table></td></tr>}

                    <tr>
                      <td colSpan="2">
                        <h3>Vouchers (will appear in the mobile app)</h3>
                        <div style={{ marginBottom: '10px' }}>
                          {(this.state.vouchers || []).map((voucherUrl, index) => (
                            <div key={`${voucherUrl}-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                              <span style={{ marginRight: '8px', minWidth: '24px' }}>{`${index + 1}.`}</span>
                              <a href={voucherUrl} target="_blank" rel="noreferrer" style={{ marginRight: '12px' }}>
                                {voucherUrl}
                              </a>
                              <Button
                                size="small"
                                style={{ minWidth: 'unset', padding: '2px 8px' }}
                                onClick={() => this.removeVoucher(index)}
                              >
                                X
                              </Button>
                            </div>
                          ))}
                        </div>
                        <Button variant="outlined" component="label" disabled={this.state.vouchersUploading}>
                          {this.state.vouchersUploading ? 'Uploading...' : 'Upload Files'}
                          <input
                            type="file"
                            hidden
                            multiple
                            onChange={this.handleVoucherUpload}
                          />
                        </Button>
                      </td>
                    </tr>

                    <tr style={{ marginTop: '20px' }}>
                      <td colSpan="4">
                        <label style={{ paddingLeft: '0px' }}>
                          <strong>
                            To make sure PDF creation succeeds, please install and activate the following plugin for Google Chrome Browser:
                          </strong>
                          <a href="https://chromewebstore.google.com/detail/cors-unblock/lfhmikememgdcahcdlaciloancbhjino?pli=1" target='_blank' rel="noreferrer">
                            https://chromewebstore.google.com/detail/cors-unblock/lfhmikememgdcahcdlaciloancbhjino?pli=1
                          </a>
                        </label>
                        {this.state.save_type === 'add' && (
                          <Button
                            id="btnSaveSN"
                            variant="contained"
                            color="primary"
                            style={{ marginRight: '8px' }}
                            onClick={this.handleSaveSelfGuide.bind(this)}
                          >
                            CREATE
                          </Button>
                        )}
                        {this.state.save_type !== 'add' && (
                          <Button
                            id="btnSaveSN"
                            variant="contained"
                            color="primary"
                            style={{ marginRight: '8px' }}
                            onClick={this.handleSaveSelfGuide.bind(this)}
                          >
                            {`SAVE CHANGES (ID: ${this.state.editableSPId})`}
                          </Button>
                        )}
                        {this.state.trip && Object.keys(this.state.trip).length > 0 &&
                          <>
                            <Button
                              id="btnViewSN"
                              variant="contained"
                              color="primary"
                              style={{ marginRight: '8px' }}
                              onClick={this.viewEmail.bind(this)}
                            >
                              VIEW
                            </Button>
                            <Button
                              id="btnSendEmailSN"
                              variant="contained"
                              color="primary"
                              onClick={this.sendEmail.bind(this)}
                            >
                              SEND EMAIL
                            </Button>
                            {this.state.loading === true ? <LoadingSpinner>Generating PDF...</LoadingSpinner> : null}
                          </>
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            </div>
          </div>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
        />

        <table cellPadding="10" className="viewdata">
          <tbody>
            <tr>
              <td>
                <h2>Personalized packages</h2>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td colSpan="3"  ></td>
              <td>&nbsp;
                <Button
                  id="btnSave"
                  variant="contained"
                  className='deleteBtn'
                  onClick={() => { this.handleClickOpen(); }}
                  style={{ float: 'right', fontSize: 12, color: '#fff' }}
                >
                  DELETE SELECTED
                </Button>
              </td>
            </tr>
            <tr>
              <td colSpan="4">
                <SelfGuidesTable setSGSearchData={this.setSGSearchData} setEditableSelfPackageId={this.setEditableSelfPackageId} allTrip={this.state.allTrip} selfGuideData={this.state.selfGuideTableData} setSelfGuideTableData={this.setSelfGuideTableData} setSelfGuideData={this.setSelfGuideData} />
              </td>
            </tr>
            <tr>
              <td colSpan="4">
                <Link href="#" onClick={() => {
                  this.setSelfGuideData(
                    ``, // confirmation_policy
                    ``, // confirmation_policy_hebrew
                    `<div>
<strong>Accommodation</strong>
<ul>
<li>Price is based on 2 adults sharing a double / twin room</li>
<li>4 nights in Moderate (3 stars) and First Class (4 stars) Hotels</li>
<li>Adjustments can be made in additional services section</li>
</ul>
</div>

<div>
<strong>Meals</strong>
<ul>
<li>4 breakfasts in the hotels</li>
</ul>
</div>

<div>
<strong>Car Rental</strong>
<ul>
<li>Price is based on 2 adults Sharing a car</li>
<li>Toyota Yaris or similar for 5 days</li>
<li>A local driver is optional with an additional payment</li>
</ul>
</div>`, // price_description

                    `<div>
  <strong>לינה</strong>
  <ul>
    <li> המחיר מבוסס על שני מבוגרים בחדר זוגי / טווין</li>
    <li> 4 לילות במלונות בדרגה מתונה (3 כוכבים) וראשונה (4 כוכבים)</li>
    <li> התאמות אפשריות בסעיף “שירותים נוספים”</li>
  </ul>
</div>

<div>
  <strong>ארוחות</strong>
  <ul>
    <li> 4 ארוחות בוקר במלונות</li>
  </ul>
</div>

<div>
  <strong>השכרת רכב</strong>
  <ul>
    <li> המחיר מבוסס על שני מבוגרים המחלקים רכב</li>
    <li> טויוטה יאריס או דומה ל־5 ימים</li>
    <li> נהג מקומי אופציונלי בתשלום נוסף</li>
  </ul>
</div>`, // price_description_hebrew

                    ``, // trip
                    ``, // photo
                    0, // selfGuide_price

                    `<ul>
 <li>Price is based on 2 person sharing a double or twin room in one car</li>
 <li>Price is based on 1 person in a single room in one car</li>
</ul>`, // selfGuide_price_includes

                    ``, // selfGuide_price_includes_hebrew

                    `<div>
<strong>On-Trip Support</strong><br />
Help during your travels by our Local Hero, service hours 09:00 - 18:00.<br /><br />
And:
<ul>
  <li>Navigational Tour Guide</li>
  <li>Seamless Navigation of Your Personalized Trip</li>
  <li>Seamless Navigation of Walking city trails</li>
  <li>Visual & Audio Tips Based on Location</li>
  <li>Curated Hiking Trails</li>
  <li>Content Info About Your Personalized Itinerary</li>
  <li>Flexible adjustments According to Your Personal Preferences</li>
</ul>
</div>`, // selfGuide_price_excluded

                    `<div>
  <strong>תמיכה במהלך הטיול</strong><br />
  סיוע במהלך הנסיעה על ידי הגיבור המקומי שלנו, שעות שירות 09:00 - 18:00.<br /><br />
  וכן:
  <ul>
    <li>מדריך טיול ניווטי</li>
    <li>ניווט חלק של המסלול האישי שלך</li>
    <li>ניווט חלק בשבילי הליכה בעיר</li>
    <li>טיפים חזותיים וקוליים המבוססים על מיקום</li>
    <li>מסלולי הליכה נבחרים</li>
    <li>מידע על תוכן המסלול האישי שלך</li>
    <li>התאמות גמישות בהתאם להעדפות האישיות שלך</li>
  </ul>
</div>`, // selfGuide_price_excluded_hebrew

                    new Date().toISOString().split('T')[0], // starting_date
                    new Date().toISOString().split('T')[0], // ending_date
                    'add', // save_type
                    '', // updateSGRowIndex
                    0, // number_travelers
                    [], // days_data
                    [], // user_data
                    [], // vouchers
                    'en' // language
                  );

                  this.setState({
                    showModal: true,
                    contentEmail: '',
                    hotelNames: [],
                    hotelOptions: [],
                    hotelSites: [],
                    overnightPostHotel: '',
                    overnightPostHotelSiteLink: '',
                    overnightPostNight: '',
                    overnightPreCity: '',
                    overnightPreHotel: '',
                    overnightPreHotelSiteLink: '',
                    searchTerm: '',
                    searchTermHotel: '',
                    searchTermOvernightHotel: '',
                    selectedEmail: '',
                    userFirstName: '',
                    userLastName: '',
                  });
                  openPopup();
                }}> + ADD NEW SELF GUIDED PACKAGE  </Link>
              </td>
            </tr>
            <tr>
              <td colSpan="4">
                <div className="borderDiv" />
              </td>
            </tr>
          </tbody>
        </table>
      </div >
    );
  }

  componentWillUnmount() {
    // Clean up debounce timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }
}

export default SelfGuidedPackagePersonalized;

mapboxgl.accessToken = MapboxKey;
// eslint-disable-next-line no-unused-vars
let mapMarkersOne = [];
// eslint-disable-next-line no-unused-vars
let mapMarkersTwo = [];
let webmapMarkers = [];
let vgmapMarkers = [];

// eslint-disable-next-line no-unused-vars
let webMapOne;
// eslint-disable-next-line no-unused-vars
let webMapTwo;
let webMap;
let vgMap;


// eslint-disable-next-line no-unused-vars
function addWebMarker(coordinates) {

  const id = _uniqueId('webmarker-');

  let marker;
  var el = document.createElement('div');
  el.className = 'marker';
  el.id = id;
  el.addEventListener(
    'click',
    (e) => {
      e.stopPropagation();
      let target_id = e.target.id;
      // let queriedMarkerObj = webmapMarkers.find((marker) => marker.id === query);
      // queriedMarkerObj.marker.remove();
      for (let i = 0; i < webmapMarkers.length; i++) {
        if (webmapMarkers[i].id === target_id) {
          document.getElementById(webmapMarkers[i].id).remove();
          webmapMarkers.splice(i, 1);
        }
      }
    },
    true
  );
  marker = new mapboxgl.Marker(el).setLngLat(coordinates).addTo(webMap);
  marker.properties = { id: id };
  webmapMarkers.push({
    id: id,
    coordinates: coordinates,
    marker,
  });
}

// eslint-disable-next-line no-unused-vars
function addVgMarker(coordinates, type = false) {
  const id = _uniqueId('vgmarker-');
  let marker;
  var el = document.createElement('div');
  el.className = 'marker';
  el.id = id;
  if (type) {
    el.style.backgroundImage = `url('https://planmytrip-assets.s3.amazonaws.com/assets/resources/countries/${getSvg(
      type
    )}.svg')`;
  }
  el.addEventListener(
    'click',
    (e) => {
      e.stopPropagation();
      let query = e.target.id;
      let queriedMarkerObj = vgmapMarkers.find((marker) => marker.id === query);
      queriedMarkerObj.marker.remove();
      pointNumbers.splice(
        pointNumbers.findIndex((v) => v.id === query),
        1
      );
    },
    true
  );
  marker = new mapboxgl.Marker(el).setLngLat(coordinates).addTo(vgMap);
  vgmapMarkers.push({
    id: id,
    coordinates: coordinates,
    marker,
  });
}

function getSvg(type) {
  type = parseInt(type);
  switch (type) {
    case 1: {
      return 'straight';
    }
    case 2: {
      return 'right';
    }
    case 3: {
      return 'left';
    }
    case 4: {
      return 'fork-left';
    }
    case 5: {
      return 'fork-right';
    }
    case 6: {
      return 'poi';
    }
    case 7: {
      return 'info';
    }
    case 8: {
      return 'swimming';
    }
    case 9: {
      return 'rafting';
    }
    case 10: {
      return 'hotel';
    }
    default: {
      return 'poi';
    }
  }
}

class SelfGuidesTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [['Loading Data...']],
      loading: false,
      localHeroRowsSelected: [],
      rowsPerPage: 10,
      page: 0,
      count: 0,
      filterData: [],
      filterBy: '',
      filterValue: '',
      searchTerm: '',
      filterState: false
    };
  }

  async componentDidMount() {
    let data = await this.getData();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('id')) {
      let id = urlParams.getAll('id');
      this.props.setEditableSelfPackageId(id[0]);
      this.setSGPackageData(id, data);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.page !== prevState.page || this.state.rowsPerPage !== prevState.rowsPerPage) {
      let data = await this.getData();
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.has('id')) {
        let id = urlParams.getAll('id');
        this.props.setEditableSelfPackageId(id[0]);
        this.setSGPackageData(id, data);
      }
    }
  }

  setSGPackageData = async (id, data) => {
    let filterId = parseInt(id[0]);
    let filterRow = await this.getSGById(filterId);
    let getIndexRow = data.findIndex(row => row.id === filterId);
    this.props.setSelfGuideData(filterRow.confirmation_policy, filterRow.confirmation_policy_hebrew, filterRow.price_description, filterRow.price_description_hebrew, filterRow.trip_id, filterRow.photo, filterRow.price, filterRow.price_includes, filterRow.price_includes_hebrew, filterRow.excluded, filterRow.excluded_hebrew, filterRow.starting_date, filterRow.ending_date, 'update', getIndexRow, filterRow.number_travelers, filterRow.days_data, filterRow.user_data, filterRow.vouchers, filterRow.language || filterRow.Language || filterRow.offerLanguage || 'en');
    openPopup();
  }

  getData = () => {
    this.setState({ loading: true });
    let dataRows = this.xhrRequest().then((data) => {
      this.setState({ data, loading: false, count: data.length });
      this.props.setSelfGuideTableData(data);
      return data;
    });
    return dataRows;
  };

  xhrRequest = async () => {
    try {
      let data = await getAllFromApi(ApiData.baseURL + `/self-guided-packages?personalized=true`);
      if (data) {
        data.results.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const tripsData = this.props.allTrip;

        // Do not hide rows while trips are still loading.
        if (!tripsData || tripsData.length === 0) {
          return data.results;
        }

        let filteredSGP = data.results.filter(sgp => {
          return tripsData && tripsData.some(trip => trip.id === sgp.trip_id);
        });
        return filteredSGP;
      } else {
        throw new Error("No data received from the API.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  getFilteredData = () => {
    if (this.state.searchTerm.length || this.state.filterValue.length) {
      this.xhrRequestFilterData().then((data) => {
        this.setState({ filterData: data, filterState: true });
        this.props.setSGSearchData(data)
        return data;
      });
    } else {
      this.setState({ filterData: this.props.tripData, filterState: false });
      this.props.setSGSearchData(this.props.tripData)
    }
  };

  xhrRequestFilterData = () => {
    return new Promise(async (resolve, reject) => {
      let data = await getDatafromApi(ApiData.apiUrlLogin + `/trips/findTrips?${this.state.searchTerm ? `internal_name=${this.state.searchTerm.toLocaleUpperCase()}&` : ''}${this.state.filterValue ? `${this.state.filterBy}=${this.state.filterValue}` : ''}`)
      if (data) {
        if (data.length) {
          data.sort((a, b) => a.id - b.id);
          resolve(data);
        } else {
          this.setState({ filterData: [] });
          this.props.setSGSearchData([]);
        }
      }
    });
  };

  getSGById = (id) => {
    return new Promise(async (resolve, reject) => {
      let data = await getDatafromApi(ApiData.apiUrl + `/self-guided-packages/${id}`);
      if (data) {
        resolve(data);
      }
    });
  };

  render() {
    const columns = [
      {
        name: 'id', options: {
          label: 'ID', filter: false,

          customBodyRender: (value, tableMeta, updateValue) => {
            // const editrow = tableMeta.tableData[tableMeta.rowIndex];
            var editrow = {};
            var rowIndexForUpdate = 0;
            var i = 0;
            tableMeta.tableData.forEach((row) => {
              if (row.id === value) {
                editrow = row;
                rowIndexForUpdate = i;
              }
              i++;
            })

            return (
              <Link href="#" onClick={() => {
                this.props.setSelfGuideData(editrow.confirmation_policy, editrow.confirmation_policy_hebrew, editrow.price_description, editrow.price_description_hebrew, editrow.trip_id, editrow.photo, editrow.price, editrow.price_includes, editrow.price_includes_hebrew, editrow.excluded, editrow.excluded_hebrew, editrow.starting_date, editrow.ending_date, 'update', rowIndexForUpdate, editrow.number_travelers, editrow.days_data, editrow.user_data, editrow.vouchers, editrow.language || editrow.Language || editrow.offerLanguage || 'en'); this.props.setEditableSelfPackageId(value); openPopup(editrow.id);
              }}>  {value}</Link>
            );
          },

        }
      },

      { name: 'trip_id', label: 'Trip Id', options: { filter: false } },
      {
        name: 'trip_id',
        options: {
          label: 'TripName',
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const { allTrip } = this.props;
            const selectedTrip = (allTrip || []).find(
              (trip) => Number(trip.id) === Number(value)
            );
            let tripName = '';
            if (selectedTrip) {
              tripName = selectedTrip.internal_name;
            } else {
              tripName = `Trip #${value}`;
            }
            return tripName;
          },
        },
      },
      { name: 'starting_date', label: 'Starting Date', options: { filter: false } },
      { name: 'number_travelers', label: 'Number of travelers', options: { filter: false } },
    ]

    const onRowsSelect = (curRowSelected, rowsSelected) => {
      selectedRowIndex = [];
      for (let i = 0; i < rowsSelected.length; i++) {
        selectedRowIndex.push(rowsSelected[i].index);
      }
      activeDeactiveDeleteBtn();
    };

    const handleChangePage = (event, newPage) => {
      this.setState({ page: event });
    };

    const handleChangeRowsPerPage = (event) => {
      this.setState({ rowsPerPage: event, page: 0 });
    };
    
    const handleOnFilterChange = (changedColumn, filterList) => {
      let filterBy = changedColumn;
      let filterValue = (filterList[3].join('') || filterList[4].join(''));
      this.setState({ filterBy, filterValue }, () => {
        this.getFilteredData();
      });
    };

    const handleOnFilterClose = () => {
      if (this.state.filterBy.length && !this.state.filterValue.length) {
        deleteFilterData();
      }
    }

    const deleteFilterData = () => {
      this.setState({ filterData: [], filterState: false, filterBy: '', filterValue: '' });
      this.props.setSGSearchData([])
    }

    const deleteSearchData = () => {
      this.setState({ filterData: [], filterState: false, searchTerm: '' });
      this.props.setSGSearchData([])
    }

    let searchTimer;
    const searchBySGPName = (searchTerm) => {
      if (searchTerm) {
        if (!isNaN(Number(searchTerm))) {
          clearTimeout(searchTimer);
          searchTimer = setTimeout(() => {
            this.setState({ searchTerm }, () => {
              this.getFilteredData();
            });
          }, 1000);
        }
        if (isNaN(Number(searchTerm)) && searchTerm.length > 3) {
          clearTimeout(searchTimer);
          searchTimer = setTimeout(() => {
            this.setState({ searchTerm }, () => {
              this.getFilteredData();
            });
          }, 1000);
        }
      } else {
        this.setState({ searchTerm: '' });
        deleteSearchData();
        selectedRowIndex = [];
        activeDeactiveDeleteBtn();
      }
    };

    const { page, rowsPerPage, count, filterState, data } = this.state;
    const { searchData } = this.props;

    const options = {
      filter: true,
      filterType: 'dropdown',
      responsive: 'standard',
      download: false,
      print: false,
      selectableRowsOnClick: false,
      selectToolbarPlacement: 'none',
      rowsSelected: selectedRowIndex,
      rowsPerPage: rowsPerPage,
      page: page,
      count: count,
      pagination: filterState ? false : true,
      onRowSelectionChange: onRowsSelect,
      onChangePage: handleChangePage,
      onChangeRowsPerPage: handleChangeRowsPerPage,
      onSearchChange: searchBySGPName,
      onFilterChange: handleOnFilterChange,
      onFilterDialogClose: handleOnFilterClose,
      onFilterChipClose: deleteFilterData,
      onSearchClose: deleteSearchData
    };

    return (
      <div>
        <MUIDataTable
          title={
            <Typography variant="subtitle2">
              {this.state.loading && (
                <CircularProgress
                  size={24}
                  style={{ marginLeft: 15, position: 'relative', top: 4 }}
                />
              )}
            </Typography>
          }
          data={filterState ? searchData : data}
          columns={columns}
          options={options}
        />
      </div>
    );
  }
}

function openPopup(id = '') {
  if (id !== '') {
    window.history.pushState(null, null, `?page=SelfGuidedPackagePersonalized&id=${id}`);
  }

  const modal = document.querySelector(".modal")
  const closeBtn = document.querySelector(".close")
  modal.style.display = "block";
  document.querySelector(".viewdata").style.display = "none";
  closeBtn.addEventListener("click", () => {
    window.history.pushState(null, null, `?page=SelfGuidedPackagePersonalized`);
    modal.style.display = "none";
    document.querySelector(".viewdata").style.display = "inline-table";
  })
}

function closePopoup() {
  window.history.pushState(null, null, `?page=SelfGuidedPackagePersonalized`);
  document.querySelector(".modal").style.display = "none";
  document.querySelector(".viewdata").style.display = "inline-table";
}

function activeDeactiveDeleteBtn() {
  const btn = document.querySelector(".deleteBtn")
  if (selectedRowIndex.length > 0) btn.style.backgroundColor = 'blue';
  else btn.style.backgroundColor = '#e0e0e0';
}
